<template>
  <div>
    <br />
    <form @submit.prevent="save(saleItem)">
      <div class="row align-items-end">
        <div class="col-xl-3 col-12 my-3">
          <label for="itemInput">Produit</label>
          <vue-select
            :options="filteredItems"
            v-model="saleItem.item_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Quantité</label>
          <input
            v-model="saleItem.quantity"
            class="form-control"
            type="number"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Prix HT</label>
          <input
            v-model="saleItem.priceHT"
            class="form-control"
            type="number"
            step="0.01"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Prix TTC</label>
          <input
            v-model="saleItem.priceTTC"
            class="form-control"
            type="number"
            step="0.01"
          />
        </div>

        <div class="col-xl col-12 my-3">
          <label for=""> Remarque </label>
          <input v-model="saleItem.remark" class="form-control" />
        </div>
      </div>

      <hr />
      <div class="row justify-content-end">
        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button class="btn btn-success shadow" type="submit">
            <i class="bi bi-plus-circle"></i> Modifier
          </button>
        </div>

        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refresh()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>
      </div>
    </form>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix HT</th>
          <th scope="col">Prix TTC</th>
          <th scope="col">Quantité</th>
          <th scope="col">Total HT</th>
          <th scope="col">Total TTC</th>
          <th scope="col">Remarque</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in saleItems" :key="index++">
          <td>{{ index + 1 }}</td>
          <td>
            <span v-if="item.item">
              {{ item.item.fullName }}
            </span>
          </td>
          <td>{{ item.priceHT }}</td>
          <td>{{ item.priceTTC }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.totalPriceHT }}</td>
          <td>{{ item.totalPriceTTC }}</td>
          <td>{{ item.remark }}</td>
          <td class="d-flex">
            <button @click="editItem(item)" class="btn text-primary me-2">
              <i class="bi bi-pencil-fill"></i>
            </button>
            <button @click="remove(item.id)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      saleItem: {},
      editingItemId: null,
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("sellerSale", {
      sellerSale: "getSellerSale",
    }),

    saleItems() {
      return (this.sellerSale && this.sellerSale.saleItems) || [];
    },

    filteredItems() {
      return this.items;
    },
  },
  methods: {
    async save(data) {
      if (!data.item_reference || !data.quantity || !data.priceTTC) {
        alert("Veuillez remplir tous les champs obligatoires");
        return;
      }
      data.totalPriceHT = (
        parseFloat(data.priceHT || 0) * parseFloat(data.quantity)
      ).toFixed(2);
      data.totalPriceTTC = (
        parseFloat(data.priceTTC || 0) * parseFloat(data.quantity)
      ).toFixed(2);
      data.id = this.editingItemId;
      data.seller_sale_reference = this.$route.params.reference;
      await this.$store.dispatch("sellerSale/updateItem", data);
      await this.$store.dispatch(
        "sellerSale/show",
        this.$route.params.reference
      );
      this.saleItem = {};
      this.editingItemId = null;
    },

    editItem(item) {
      this.saleItem = { ...item };
      this.editingItemId = item.id;
    },

    async remove(id) {
      await this.$store.dispatch("sellerSale/destroyItem", id);
      await this.$store.dispatch(
        "sellerSale/show",
        this.$route.params.reference
      );
    },

    async refresh() {
      await this.$store.dispatch(
        "sellerSale/show",
        this.$route.params.reference
      );
      this.saleItem = {};
      this.editingItemId = null;
    },
  },
  beforeMount() {
    this.$store.dispatch("item/getAll");
    this.$store.dispatch("sellerSale/show", this.$route.params.reference);
  },
};
</script>
